import { render, staticRenderFns } from "./Boekingen.vue?vue&type=template&id=1d54fe34&scoped=true&"
import script from "./Boekingen.vue?vue&type=script&lang=js&"
export * from "./Boekingen.vue?vue&type=script&lang=js&"
import style0 from "./Boekingen.vue?vue&type=style&index=0&id=1d54fe34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54fe34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d54fe34')) {
      api.createRecord('1d54fe34', component.options)
    } else {
      api.reload('1d54fe34', component.options)
    }
    module.hot.accept("./Boekingen.vue?vue&type=template&id=1d54fe34&scoped=true&", function () {
      api.rerender('1d54fe34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Boekingen.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Boekingen.vue
// module id = 436
// module chunks = 0